// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { TileSize, ListType, TileSizeMobile } from '../../_components/ui';
import { ModuleAdditionalRows } from '../../_contracts';
import { TeaserBoxVersion } from '../TeaserBox.contracts';
import { TeaserBoxAddonsMixin } from '../TeaserBox.shared';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Michał Rossian <michal.rossian@movecloser.pl>
 */
let TeaserBoxInnerGrid6STextList = class TeaserBoxInnerGrid6STextList extends TeaserBoxAddonsMixin {
    constructor() {
        super(...arguments);
        this.gridConfig = {
            defaultSize: TileSize.S,
            mobileSize: TileSizeMobile.TILE_PLUS_TEXT,
            tiles: { 0: TileSize.S },
            listOffset: 6,
            listType: ListType.LIST
        };
    }
    get tilesOffset() {
        switch (this.teaserBoxConfig.additionalRows) {
            case ModuleAdditionalRows.addOne:
                return this.gridConfig.listOffset + 3;
            case ModuleAdditionalRows.addTwo:
                return this.gridConfig.listOffset + 6;
            default:
                return this.gridConfig.listOffset;
        }
    }
};
TeaserBoxInnerGrid6STextList.moduleVersion = TeaserBoxVersion['6S-text-list'];
TeaserBoxInnerGrid6STextList = __decorate([
    Component({
        name: 'TeaserBoxInnerGrid6STextList'
    })
], TeaserBoxInnerGrid6STextList);
export { TeaserBoxInnerGrid6STextList };
